export default "__VITE_ASSET__Ba_Pn4YV__"